import React from "react";
import Masonry from "react-masonry-component";
import "../styales/NewsList.css";

const NewsList = (props) => {
  const articles = props.articles.map((article, index) => {
    return (
      <div key={index} className="ui medium news">
        <a href={article.url} target="_blank" rel="noopener noreferrer">
          <h2>{article.title}</h2>
        </a>
        <a
          href={article.url}
          target="_blank"
          rel="noopener noreferrer"
          className="news-container"
        >
          <img
            src={article.urlToImage}
            alt={article.tags}
            style={{ width: "50vw" }}
            className="news-list"
          ></img>
        </a>

      </div>
    );
  });
  return <Masonry className="article-list">{articles}</Masonry>;
};

export default NewsList;
